module.exports = __webpack_public_path__ + "img/h2@2x.f2e7db49.png";